
import * as React from "react";
import { cn } from "@/lib/utils";

interface StepsProps {
  children: React.ReactNode;
  className?: string;
}

export interface StepProps {
  title: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  stepNumber?: number;
  isLast?: boolean;
}

export function Steps({ children, className }: StepsProps) {
  const steps = React.Children.toArray(children) as React.ReactElement<StepProps>[];
  
  return (
    <div className={cn("space-y-8", className)}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        
        return React.cloneElement(step, {
          ...step.props,
          stepNumber,
          isLast: index === steps.length - 1,
          key: index,
        });
      })}
    </div>
  );
}

export function Step({
  title,
  icon,
  children,
  className,
  stepNumber,
  isLast,
}: StepProps) {
  return (
    <div className={cn("relative", className)}>
      <div className="flex items-center">
        <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-primary text-primary-foreground">
          {icon ? icon : <span className="text-sm font-medium">{stepNumber}</span>}
        </div>
        <h3 className="ml-3 text-lg font-medium">{title}</h3>
      </div>
      
      {children && <div className="ml-11">{children}</div>}
      
      {!isLast && (
        <div className="absolute left-4 top-8 h-full w-[1px] bg-border -z-10"></div>
      )}
    </div>
  );
}
